/*
 * File: FancyInputSearch.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 09 Dec 2021 1:42:30 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Input } from 'antd';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { ChangeEvent, FC, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface FancyInputSearchProps {
  value: string | undefined;
  placeHolder: string;
  disabled?: boolean;
  width?: number;
  handleSearch: (value: string) => void;
  handleChange: (ev: ChangeEvent<HTMLInputElement>) => void;
  defaultValue?: string;
  inputValue?: string | undefined;
}

const styles: InlineStylesModel = {
  form: {
    position: 'relative'
  },
  borderAnimation: {
    // transform: 'translateX(-100%)',
    transition: 'all 0.3s ease'
  },
  input: {
    width: '100%',
    minWidth: 125
  },
  labelUnfocused: {
    position: 'absolute',
    color: 'rgba(0,0,0,0.50)',
    top: 5,
    left: 10,
    zIndex: 2,
    transition: 'all 0.3s ease'
  },
  labelFocused: {
    backgroundColor: 'white',
    position: 'absolute',
    paddingLeft: 5,
    paddingRight: 5,
    zIndex: 2,
    top: -15,
    left: 8,
    transition: 'all 0.3s ease'
  }
};

export const FancyInputSearch: FC<FancyInputSearchProps> = ({ value, placeHolder, handleSearch, handleChange, width, inputValue }: FancyInputSearchProps) => {
  const [isLabelTop, _setIsLabelTop] = useState(false);
  const { pathname } = useLocation();
  const isPosted = pathname.includes('/posted');

  const inputRef = useRef(null);

  const inputWidth = width ? { ...styles.input, ...{ width } } : styles.input;

  const handleFocus = (): void => {
    _setIsLabelTop(true);
  };

  const onLabelClick = (): void => {
    if (!isLabelTop) {
      _setIsLabelTop(true);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (inputRef.current as any).focus();
    }
  };

  const handleBlur = (): void => {
    if (!value) {
      _setIsLabelTop(false);
    }
  };

  return (
    <div style={isLabelTop ? { ...styles.form, ...styles.borderAnimation } : styles.form}>
      <Input.Search
        disabled={isPosted}
        ref={inputRef}
        enterButton="+"
        value={inputValue}
        style={inputWidth}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onSearch={handleSearch}
        onChange={handleChange}
        allowClear
      />
      <label style={isLabelTop ? styles.labelFocused : styles.labelUnfocused} onClick={onLabelClick}>
        <span>{placeHolder}</span>
      </label>
    </div>
  );
};
